import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "components/Loadable";
import DashboardLayout from "layout/Dashboard";

// Lazy load pages
const Home = Loadable(lazy(() => import("pages/home")));
const Veille = Loadable(lazy(() => import("pages/veille/veille")));
const VeilleDetails = Loadable(
  lazy(() => import("pages/veille/VeilleDetails")),
);
const Avis = Loadable(lazy(() => import("pages/avis/avis")));
const AvisDetails = Loadable(lazy(() => import("pages/avis/avisDetails")));
const Modules = Loadable(lazy(() => import("pages/modules")));
const Formation = Loadable(lazy(() => import("pages/formation")));
const FormationProfile = Loadable(lazy(() => import("pages/formationProfile")));
const FormationModules = Loadable(lazy(() => import("pages/formationModules")));
const MedicalFormationComingSoon = Loadable(
  lazy(() => import("pages/maintenance/coming-soon/coming-soon2")),
);
const Masterclass = Loadable(lazy(() => import("pages/masterclass")));
const MasterclassProfile = Loadable(lazy(() => import("pages/masterclassProfile")));
const MasterclassModules = Loadable(lazy(() => import("pages/masterclassModules")));
const Agenda = Loadable(lazy(() => import("pages/agenda")));
const EventDetails = Loadable(lazy(() => import("pages/events/EventDetails")));
const Experts = Loadable(lazy(() => import("pages/experts")));
const ExpertProfile = Loadable(lazy(() => import("pages/expertProfile")));
const Institutions = Loadable(lazy(() => import("pages/institutions")));
const InstitutionsProfile = Loadable(
  lazy(() => import("pages/institutionsProfile")),
);
const Learning = Loadable(lazy(() => import("pages/apprentissage")));
const Favorites = Loadable(lazy(() => import("pages/favorites")));
const Newsletter = Loadable(lazy(() => import("pages/newsletter")));
const LibraryPage = Loadable(lazy(() => import("pages/library/library")));
const LibraryDetails = Loadable(lazy(() => import("pages/library/LibraryDetails")));
const Tamwil = Loadable(lazy(() => import("pages/tamwil/tamwil")));
const ProgrammeProfile = Loadable(
  lazy(() => import("pages/tamwil/programmeProfile")),
);
const ContribuerPage = Loadable(lazy(() => import("pages/contribuer")));
const Certificates = Loadable(lazy(() => import("pages/certificates")));
// const UserProfile = Loadable(lazy(() => import("layout/Profile/user")));

const MeducateAIAssistant = Loadable(lazy(() => import("pages/assistant-ia")));

const AccountProfile = Loadable(lazy(() => import("layout/Profile/account")));
const AccountTabProfile = Loadable(
  lazy(() => import("pages/profile/account/TabProfile")),
);
const AccountTabPersonal = Loadable(
  lazy(() => import("pages/profile/account/TabPersonal")),
);
const AccountTabDashboard = Loadable(
  lazy(() => import("pages/profile/account/dashboard")),
);
const LeaderboardPage = Loadable(
  lazy(() => import("pages/profile/account/dashboard/leaderboard")),
);
const LogsPage = Loadable(
  lazy(() => import("pages/profile/account/dashboard/logs")),
);
const AccountTabPassword = Loadable(
  lazy(() => import("pages/profile/setting/TabPassword")),
);
const AccountTabSettings = Loadable(
  lazy(() => import("pages/profile/setting/TabSettings")),
);
const AccomplishmentVerify = Loadable(
  lazy(() => import("pages/AccomplishmentVerify")),
);

// const TabPersonal = Loadable(
//   lazy(() => import("pages/profile/account/TabPersonal")),
// );
// const UserTabPassword = Loadable(
//   lazy(() => import("pages/profile/account/TabPassword")),
// );
// const UserTabNotifications = Loadable(
//   lazy(() => import("pages/profile/account/TabNotifications")),
// );
const MaintenanceError = Loadable(
  lazy(() => import("pages/maintenance/error/404")),
);

const MainRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: <DashboardLayout />,
      children: [
        {
          path: "home",
          element: <Home />,
        },
        {
          path: "formation",
          element: <Formation />,
        },
        {
          path: "formation/:id",
          element: <FormationProfile />,
        },
        {
          path: "formation/:formationId/modules",
          element: <FormationModules />,
        },
        {
          path: "formation/:formationId/modules/:moduleOrder",
          element: <FormationModules />,
        },
        {
          path: "accomplishments/verify/:accomplishmentId",
          element: <AccomplishmentVerify />,
        },
        {
          path: "modules",
          element: <Modules />,
        },
        {
          path: "veille",
          element: <Veille />,
        },
        {
          path: "veille/:id",
          element: <VeilleDetails />,
        },
        {
          path: "avis",
          element: <Avis />,
        },
        {
          path: "avis/:id",
          element: <AvisDetails />,
        },
        {
          path: "experts",
          element: <Experts />,
        },
        {
          path: "experts/:id",
          element: <ExpertProfile />,
        },
        {
          path: "institutions",
          element: <Institutions />,
        },
        {
          path: "institutions/:id",
          element: <InstitutionsProfile />,
        },
        {
          path: "masterclass",
          element: <Masterclass />,
        },
        {
          path: "masterclass/:id",
          element: <MasterclassProfile />,
        },
        {
          path: "masterclass/:formationId/modules",
          element: <MasterclassModules />,
        },
        {
          path: "masterclass/:formationId/modules/:moduleOrder",
          element: <MasterclassModules />,
        },
        {
          path: "agenda",
          element: <Agenda />,
        },
        {
          path: "event/:id",
          element: <EventDetails />,
        },
        {
          path: "apprentissage",
          element: <Learning />,
        },
        {
          path: "favorites",
          element: <Favorites />,
        },
        {
          path: "newsletter",
          element: <Newsletter />,
        },
        {
          path: "library",
          element: <LibraryPage />,
        },
        {
          path: "library/:id",
          element: <LibraryDetails />,
        },
        {
          path: "tamwil",
          element: <Tamwil />,
        },
        {
          path: "tamwil/:id",
          element: <ProgrammeProfile />,
        },
        {
          path: "contribuer",
          element: <ContribuerPage />,
        },
        {
          path: "certificats",
          element: <Certificates />,
        },
        // Add the new assistant-ia route
        {
          path: "assistant-ia",
          element: <MeducateAIAssistant />,
        },
        // Add the new assistant-ia route
        {
          path: "MedicalFormationComingSoon",
          element: <MedicalFormationComingSoon />,
        },
        {
          path: "profile",
          children: [
            {
              path: "account",
              // element: <AccountProfile />,
              children: [
                {
                  path: "basic",
                  element: <AccountTabProfile />,
                },
                {
                  path: "personal",
                  element: <AccountTabPersonal />,
                },
                {
                  path: "dashboard",
                  children: [
                    {
                      index: true,
                      element: <AccountTabDashboard />,
                    },
                    {
                      path: "leaderboard",
                      element: <LeaderboardPage />,
                    },
                    {
                      path: "logs",
                      element: <LogsPage />,
                    },
                  ],
                },
              ],
            },
            {
              path: "setting",
                element: <AccountProfile />,
                children: [
                  {
                    path: "interests",
                    element: <Navigate to="../my-account" replace />,
                  },
                  {
                    path: "my-account",
                    element: <AccountTabPassword />,
                  },
                  {
                    path: "notification",
                    element: <AccountTabSettings />,
                  },
                  {
                    path: "settings",
                    element: <Navigate to="../notification" replace />,
                  },
                  {
                    path: "verification",
                    element: <Navigate to="../my-account" replace />,
                  },
                ],
            },
          ],
          // children: [
          //   {
          //     path: "setting",
          //     element: <AccountProfile />,
          //     children: [
          //       {
          //         path: "interests",
          //         element: <AccountTabRole />,
          //       },
          //       {
          //         path: "my-account",
          //         element: <AccountTabPassword />,
          //       },
          //       {
          //         path: "settings",
          //         element: <AccountTabSettings />,
          //       },
          //     ],
          //   },
          // ],
        },
        {
          path: "formationProfile",
          element: <FormationProfile />,
        },
      ],
    },
    {
      path: "*",
      element: <MaintenanceError />,
    },
  ],
};

export default MainRoutes;
